import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { colors } from 'utils/colors';

export const ContainerMenuNav = styled.div`
  position: fixed;
  top: 95px;
  left: 0;
  width: 100%;
  padding: 25px;
  z-index: 100;
  border: 1px solid ${colors.verde};
  color: ${colors.preto};
  background-color: ${colors.branco};
  display: flex;
  flex-direction: column;
`;

export const ListMenu = styled(NavLink)`
  width: 100%;
  color: ${colors.verde};
  text-decoration: none;
`;

export const MobileMenu = styled.div`
  display: none;
  height: 80px;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
  position: relative;
  @media (max-width: 768px) {
    display: flex !important;
  }
`;
